import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class WorkFlowStepUser extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            workFlowStepId: props.WorkFlowStepId,
            solutionId: props.SolutionId,
            caller: props.Caller,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/solution/workflow/step/user/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/solution/workflow/step/user/save", {
            id: this.state.id,
            workFlowStepId: this.state.workFlowStepId,
            solutionRoleId: this.state.data.record.solutionRoleId,
            personId: this.state.data.record.personId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setPerson(e) {
        this.state.data.record.personId = e.value;
        this.state.data.record.personName = e.label;
    }
    setRole(e) {
        this.state.data.record.solutionRoleId = e.value;
        this.state.data.record.solutionRoleName = e.label;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات مجری/مسئول کاری" : "افزودن مجری/مسئول جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-8">
                                            <div className="form-group">
                                                <label for="name" className="title1">مجری/مسئول</label><span className="red">*</span>
                                                <SelectAsync
                                                defaultValue={this.state.data.record.personId != this.getDefaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب مجری/مسئول"
                                                    defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadSolutionUsersOptions(inputValue, callback, this.state.solutionId)}
                                                onChange={e => this.setPerson(e)}
                                                />
                                            </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">نقش</label><span className="red">*</span>
                                            <SelectAsync
                                                defaultValue={this.state.data.record.solutionRoleId != this.getDefaultGuid() ? [{ value: this.state.data.record.solutionRoleId, label: this.state.data.record.solutionRoleName }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب نقش"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadSolutionRolesOptions(inputValue, callback, this.state.solutionId)}
                                                onChange={e => this.setRole(e)}
                                            />
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}